import {refreshAllSliders} from '../../../../aus_project/Resources/Private/TypeScript/Controllers/SliderController';

export default class TabNavigationController {
  private readonly tabContentOpenClass = 'tab__contentBody--open';
  private readonly tabMobileHeaderActiveClass = 'tab__contentMobileHeader--active';

  constructor() {
    const allTabGroups = document.querySelectorAll('.js-tabs');
    allTabGroups.forEach(tabGroup => this.initTabGroup(tabGroup));
  }

  initTabGroup(tabGroup) {
    const tabTitles = tabGroup.querySelectorAll('.js-tabTitle');
    tabTitles.forEach((singleTabWrapper) => {
      singleTabWrapper.addEventListener('click', (event) => {
        const tabId = event.target.dataset.id;
        if (!tabId) {
          return;
        }
        this.openTab(tabGroup, tabId, false);
        this.activateTabHeader(tabGroup, tabId);
      });
    });

    const mobileTabTitles = tabGroup.querySelectorAll('.js-mobileTabHeader');
    mobileTabTitles.forEach((singleMobileTabTitle) => {
      singleMobileTabTitle.addEventListener('click', (event) => {
        const tabId = singleMobileTabTitle.dataset.id;
        if (!tabId) {
          return;
        }
        this.openTab(tabGroup, tabId, true);
        this.activateMobileTabHeader(tabGroup, tabId, true);
      });
    });

    // activate first Tab
    const firstTab = tabGroup.querySelector('.js-tabTitle');
    if (firstTab instanceof HTMLElement) {
      firstTab.click();
    }

    // activate tab from hash
    // cut of "#c" of content element id
    const hash = window.location.hash.substring(2);
    if (!hash) {
      return;
    }
    tabGroup.querySelectorAll('.js-tabTitle').forEach((tab) => {
      if (!(tab instanceof HTMLElement)) {
        return;
      }
      if (tab.dataset.id === hash) {
        tab.click();
      }
    });

    const allTabContent = document.querySelectorAll('.js-tabContent');
    allTabContent.forEach(tabContent => {
      let allContentId = tabContent.querySelectorAll('[id^="c"]');
      allContentId.forEach(singleContentId => {
        let contentId = singleContentId.id.substring(1);
        if (contentId === hash) {
          const tabDataElement = tabContent.getAttribute('data-tabelement');
          if (tabDataElement) {
            const tabId = parseInt(tabDataElement, 10);
            this.openTab(tabGroup, tabId, false);
            this.activateTabHeader(tabGroup, tabId);
          }
        }
      });
    });
  }

  openTab(tabGroup, tabId: number, toggleActive: boolean) {
    const newTab = tabGroup.querySelector('.js-tabContent[data-tabelement="' + tabId + '"]');
    if (!newTab) {
      return;
    }
    if (toggleActive) {
      const oldTabWasActive = newTab.classList.contains(this.tabContentOpenClass);
      tabGroup.querySelectorAll('.' + this.tabContentOpenClass).forEach(tabContent => {
        tabContent.classList.remove(this.tabContentOpenClass);
      });
      if (oldTabWasActive) {
        newTab.classList.remove(this.tabContentOpenClass);
      } else {
        newTab.classList.add(this.tabContentOpenClass);
      }
    } else {
      tabGroup.querySelectorAll('.' + this.tabContentOpenClass).forEach(tabContent => {
        tabContent.classList.remove(this.tabContentOpenClass);
      });
      newTab.classList.add(this.tabContentOpenClass);
    }

    refreshAllSliders(newTab);
  }

  activateTabHeader(tabGroup, tabId: number | string) {
    tabGroup.querySelectorAll('.tab__navigationTitle--active').forEach(tabContent => {
      tabContent.classList.remove('tab__navigationTitle--active');
    });
    const newTabTitle = tabGroup.querySelector('.js-tabTitle[data-id="' + tabId + '"]');
    newTabTitle.classList.add('tab__navigationTitle--active');
    const arrow = tabGroup.querySelector('.js-arrow');
    const line = tabGroup.querySelector('.js-tabLine');
    if (!(arrow instanceof HTMLElement) || !(line instanceof HTMLElement)) {
      return;
    }
    const titleBoundingBox = newTabTitle.getBoundingClientRect();
    const difference = 0 - line.getBoundingClientRect().left;
    arrow.style.left = difference + titleBoundingBox.left + (titleBoundingBox.width / 2) - 7 + 'px';
  }

  activateMobileTabHeader(tabGroup, tabId: number | string, toggleActive: boolean) {
    const newTabTitle = tabGroup.querySelector('.js-mobileTabHeader[data-id="' + tabId + '"]');
    if (!newTabTitle) {
      return;
    }
    if (toggleActive) {
      const oldTabWasActive = newTabTitle.classList.contains(this.tabMobileHeaderActiveClass);
      tabGroup.querySelectorAll('.' + this.tabMobileHeaderActiveClass).forEach(tabContent => {
        tabContent.classList.remove(this.tabMobileHeaderActiveClass);
      });
      if (oldTabWasActive) {
        newTabTitle.classList.remove(this.tabMobileHeaderActiveClass);
      } else {
        newTabTitle.classList.add(this.tabMobileHeaderActiveClass);
      }
    } else {
      tabGroup.querySelectorAll('.tab__contentMobileHeader--active').forEach(tabContent => {
        tabContent.classList.remove(this.tabMobileHeaderActiveClass);
      });
      newTabTitle.classList.add(this.tabMobileHeaderActiveClass);
    }
  }
}
